import React from "react";
import { useAppSelector } from "../../../../../../store/index.ts";
import CusButton from "../../../../../mui/CusButton.jsx";
import IconTg from "../../../../../../images/jsIcons/IconTg.jsx";
import { useTranslation } from "react-i18next";

export default function SendBtn({ postTips, amount }) {
  const { t } = useTranslation();
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  const btnText = amount ? `${t("Send")} ${amount} ${t("tk")}` : "Send";

  const btnProps = { type: "button", color: "red", onClick: postTips, disabled: !amount };

  return isMobile ? (
    <CusButton {...btnProps} className="send-mobile" icon={<IconTg />} />
  ) : (
    <CusButton {...btnProps} text={btnText} />
  );
}
